var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    viewBox: "0 0 299.99 299.99",
    style: {
      enableBackground: "new 0 0 299.99 299.99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M149.995,0C67.156,0,0,67.158,0,149.995S67.156,299.99,149.995,299.99c82.837,0,149.995-67.158,149.995-149.995 S232.831,0,149.995,0z M149.995,234.281c-17.709,0-34.292-4.16-48.573-11.383c-3.826,3.063-21.135,15.764-38.31,9.822 c10.382-9.832,12.275-21.301,12.024-29.269c-13.728-14.545-21.97-33.162-21.97-53.456c0.003-46.552,43.354-84.292,96.829-84.292 c53.477,0,96.829,37.739,96.829,84.292C246.824,196.548,203.472,234.281,149.995,234.281z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.830a9f881bb9a024a6ba2e1e4adae4bd.svg";
export { ForwardRef as ReactComponent };